// extracted by mini-css-extract-plugin
export default {"root":"styles_root__x-twF","loading":"styles_loading__ppmLa"};